// Utils and Constants
import {
  downloadFile,
  sendCreateOrUpdateRequest,
  sendGetRequest,
} from "../utils/api/apiUtils";
import { DefaultPagination } from "../constants/GeneralConstants";
import { getToken } from "../utils/token";

// Urls
import {
  getCityConfigUrl,
  uploadCityConfigUrl,
  downloadCityConfigExcelTemplateUrl,
} from "../urls/OrgCityConfigURL";

export async function getCityConfigFn(cityId, configType) {
  const params = {
    _city: cityId,
    _type: configType,
    pn: DefaultPagination.pageNumber,
    ps: DefaultPagination.pageSize,
  };

  return sendGetRequest(getCityConfigUrl, params);
}

export async function uploadCityConfigFn(
  cityId,
  isTouchPoint = false,
  formData
) {
  // Request Params
  const params = { cityId, isTouchPoint };

  return sendCreateOrUpdateRequest(
    uploadCityConfigUrl,
    formData,
    true,
    "POST",
    {},
    params
  );
}

export async function downloadCityConfigExcelTemplateFn(isTouchPoint = false) {
  // Request Headers
  const headerParams = {
    Authorization: "Bearer " + getToken(),
  };

  // params
  const params = { isTouchPoint };

  return downloadFile(
    downloadCityConfigExcelTemplateUrl,
    true,
    headerParams,
    params
  );
}
